import React, { useState } from "react";
import { IoCloudDownloadOutline, IoClose } from "react-icons/io5";
import styled from "styled-components";

const ProgressContainer = styled.div`
  position: fixed;
  bottom: 1em;
  right: 1em;
  width: 20em;
  background-color: ${({ theme }) => theme.custom};
  border: 1px solid ${({ theme }) => theme.border3};
  border-radius: 7px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1em;
  z-index: 1000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5em;

  h3 {
    font-size: 0.8em;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.text};
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
`;

const LoadingContainer = styled.div`
  width: 100%;
  margin: 10px 0;
`;

const LoadingBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: #eee;
  border-radius: 2px;
  overflow: hidden;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 20%;
    background-color: #4a90e2;
    border-radius: 2px;
    animation: loading 1s infinite ease-in-out;
  }

  @keyframes loading {
    0% {
      left: -20%;
    }
    100% {
      left: 100%;
    }
  }
`;

const StatusText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2em;
  margin-bottom: 0.5em;

  .filename {
    font-size: 0.9em;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
  }

  .size {
    font-size: 0.8em;
    color: ${({ theme }) => theme.text};
    opacity: 0.7;
  }
`;

const formatBytes = (bytes, decimals = 2) => {
  if (!bytes || isNaN(bytes)) return "0 B";
  if (bytes === 0) return "0 B";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const DownloadProgress = ({ show, onClose, fileName, loaded }) => {
  if (!show) return null;

  return (
    <ProgressContainer>
      <Header>
        <h3>{fileName}</h3>
        <button onClick={onClose}>
          <IoClose />
        </button>
      </Header>

      <StatusText>
        <span className="size">{formatBytes(loaded)} baixados</span>
      </StatusText>

      <LoadingContainer>
        <LoadingBar />
      </LoadingContainer>

      <div
        style={{
          fontSize: "0.8em",
          color: "#666",
          textAlign: "center",
        }}
      >
        Baixando arquivo...
      </div>
    </ProgressContainer>
  );
};

const DownloadButtons = ({ onDownload }) => {
  const [downloadProgress, setDownloadProgress] = useState({
    show: false,
    fileName: "",
    loaded: 0,
  });

  const handleDownload = async (fileName, fileType) => {
    setDownloadProgress({
      show: true,
      fileName,
      loaded: 0,
    });

    try {
      await onDownload(fileName, fileType, (progressEvent) => {
        const loaded = progressEvent.loaded;

        setDownloadProgress((prev) => ({
          ...prev,
          loaded: loaded || 0,
        }));
      });

      setTimeout(() => {
        setDownloadProgress((prev) => ({ ...prev, show: false }));
      }, 2000);
    } catch (error) {
      console.error("Erro no download:", error);
      setDownloadProgress((prev) => ({ ...prev, show: false }));
    }
  };

  return (
    <div className="buttons">
      <div
        className="btn"
        onClick={() => handleDownload("relatorio_completo.zip", "report")}
      >
        <IoCloudDownloadOutline />
        <p>BAIXAR RELATÓRIO COMPLETO</p>
      </div>

      <div
        className="btn"
        onClick={() => handleDownload("xmls_encontrados.zip", "zip")}
      >
        <IoCloudDownloadOutline />
        <p>BAIXAR XMLs ENCONTRADOS</p>
      </div>

      <div
        className="btn"
        onClick={() => handleDownload("chaves_faltantes.txt", "txt")}
      >
        <IoCloudDownloadOutline />
        <p>BAIXAR CHAVES FALTANTES</p>
      </div>

      <DownloadProgress
        {...downloadProgress}
        onClose={() =>
          setDownloadProgress((prev) => ({ ...prev, show: false }))
        }
      />
    </div>
  );
};

export { DownloadButtons as default, DownloadProgress };
